import type { ComputerUseReadiness } from '@heidi/plugin-rpa';

import type {
  PermissionName,
  PermissionStatus,
  PermissionStatusMap,
} from '@heidi/agents/contracts';
import { requiredPermissions } from '../matrix';
import { emptyPermissionStatusMap } from './check-permissions';
import { deriveMissingPermissions } from './derive-missing-permissions';

const statusFromReadiness = (
  state: ComputerUseReadiness['screen_capture']
): PermissionStatus => {
  switch (state) {
    case 'granted':
      return 'granted';
    case 'granted_needs_relaunch':
      return 'needs_relaunch';
    case 'denied':
    case 'unsupported':
      return 'denied';
    default: {
      const exhaustive: never = state;
      return exhaustive;
    }
  }
};

export const computerUseStatuses = (
  readiness: ComputerUseReadiness
): PermissionStatusMap => ({
  ...emptyPermissionStatusMap(),
  screen_recording: statusFromReadiness(readiness.screen_capture),
  accessibility: statusFromReadiness(readiness.accessibility),
});

export const missingComputerUsePermissions = (
  statuses: PermissionStatusMap
): PermissionName[] =>
  deriveMissingPermissions(requiredPermissions('computer_use'), statuses);
